export default __webpack_public_path__ + "static/media/icn-location.fd336755.svg";